import * as yup from 'yup';
import i18n from '../../i18n/i18n';

export const forgotPasswordSchema = yup.object().shape({
  email: yup.string()
      .required(() => i18n.t('validation.emailOrRegistrationNumberIsRequired'))
      .test(
        'email-or-username',
        () => i18n.t('validation.enterAValidEmailOrRegistration'),
        (value) => {
          if (!value) return false;
  
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
          // only treat as email if it has @ and a dot after it (real email pattern)
          const looksLikeEmail =
            value.includes('@') &&
            value.substring(value.indexOf('@')).includes('.');
  
          if (looksLikeEmail) {
            return emailRegex.test(value);
          }
  
          // allow usernames like abc@, student@12, REG123
          return true;
        }
      ),
  password: yup
    .string()
    .required(() => i18n.t('validation.passwordIsRequired'))
    .min(6, () => i18n.t('validation.passwordMustBeAtLeast6'))
    .max(50, () => i18n.t('validation.passwordMustBeAtMost50'))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&^()_+=-]).*$/,
      () => i18n.t('validation.useUppercaseLowercaseNumberSymbol')
    ),
});

export const verifyOtpSchema = yup.object().shape({
  otp: yup
    .string()
    .required(() => i18n.t('validation.required'))
    .min(6, () => i18n.t('validation.otpMustBe6Digits'))
    .max(6, () => i18n.t('validation.otpMustBe6Digits')),
});

export const whatsAppSettingSchema = yup.object().shape({
  token: yup
    .string()
    .required(() => i18n.t('validation.tokenIsRequired')),
   phoneNumberId: yup
    .string()
    .required(() => i18n.t('validation.phoneNumberIsRequired'))
    .matches(/^\d+$/, () => i18n.t('validation.phoneNumberMustContainOnlyNumbers')),
});